import { uploadImage } from 'common/api/fetcher/image/mutations'
import { ImageModel } from 'domain/image/model'
import { useMutation } from 'react-query'

export const useUploadImage = () =>
  useMutation<ImageModel, Error, FormData>({
    mutationFn: (formData) => uploadImage(formData),
  })
